import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Outlet, useLoaderData, useLocation, useParams } from "react-router";

import Schedule from "../../components/Schedule";
import { useAppDispatch } from "../../hooks/reduxHooks";
import { getTeamSchedule } from "../../lib/api";
import { IGame, ITeamSchedule } from "../../types/api";

export const loader = async ({ params }: any) => {
    const { teamId } = params;

    const [{ schedule }] = await Promise.all([getTeamSchedule(teamId)]);

    return {
        teamId,
        schedule,
    };
};

const ClubhouseTeamSchedule = (): React.JSX.Element => {
    const { teamId } = useParams() as { teamId: string };
    const { schedule: loadedSchedule } = useLoaderData() as {
        schedule: ITeamSchedule;
    };
    const location = useLocation();
    const dispatch = useAppDispatch();
    const isOnSchedulePage = /coachs-clubhouse\/team\/\d+\/schedule?$/.test(
        location.pathname,
    );
    const [schedule, setSchedule] = useState<IGame[]>(
        loadedSchedule?.games || [],
    );

    const scheduled =
        schedule?.filter(g => !["Postponed"].includes(g.status)) || [];

    return isOnSchedulePage ? (
        <div
            data-testid="clubhouseTeamScheduleContent"
            className="clubhouseTeamScheduleContent"
        >
            <Container>
                <Row>
                    <Col>
                        {scheduled.length ? (
                            <Row>
                                <Col>
                                    <Schedule
                                        schedule={scheduled as IGame[]}
                                        setSchedule={setSchedule}
                                        scheduleHeader="Team Schedule"
                                        showButtons={false}
                                        scheduleType="team"
                                    />
                                </Col>
                            </Row>
                        ) : (
                            <h2>No upcoming games</h2>
                        )}
                    </Col>
                </Row>
            </Container>
        </div>
    ) : (
        <Outlet />
    );
};

export default ClubhouseTeamSchedule;
